import { GWMarketDataQueryBucket, GWMarketDataSummaryBucket } from '../../models/gateway/types';
import { BBOData, MDSFeed, OHLCV, SymbolStatus, TradeData } from '../../models/market-data/types';
import { QueriesCacheType } from '../../models/trading/types';
import { NullableNumber, OrderTicketComponent } from '../../util/types';

export enum WatchlistItemState {
  INITIAL,
  LOADED,
  FAILED,
}

export interface BasicSymbolStat {
  open: NullableNumber;
  low: NullableNumber;
  high: NullableNumber;
  prevClose: NullableNumber;
  prevVolume: NullableNumber;
}

export type InstrumentSnapshotData = {
  sym: string
  absoluteChange: NullableNumber
  askPrice: NullableNumber
  bidPrice: NullableNumber
  date: string
  lastPrice: NullableNumber
  percentageChange: NullableNumber
  prevAbsoluteChange: NullableNumber
  prevClose: NullableNumber
  prevDate: string
  prevHigh: NullableNumber
  prevLastPrice: NullableNumber
  prevLow: NullableNumber
  prevOpen: NullableNumber
  prevPercentageChange: NullableNumber
  prevVolume: NullableNumber
  sumPriceXSize: NullableNumber
  // the following properties marked with ? are sometimes not available
  open?: NullableNumber
  high?: NullableNumber
  low?: NullableNumber
  close?: NullableNumber
  volume?: NullableNumber
}
export type InstrumentSnapshotMap = { [symbol: string]: InstrumentSnapshotData }
export type InstrumentSnapshotPayload = {
  symbolOrSymbols: string
  queryCache: QueriesCacheType | {}
  data: InstrumentSnapshotMap
}

export type BBODataCache = { [symbol: string]: BBOData };
export type TradeDataCache = { [symbol: string]: TradeData };
export type SymbolStatusDataCache = { [symbol: string]: SymbolStatus };

export type GetWatchlistDataPayload = {
  /** Comma separated string */
  symbolOrSymbols: string
  component: OrderTicketComponent
  isInitialLoading?: boolean
  caller: string
}

export type GetCustomWatchlistDataPayload = {
  /** Comma separated string */
  symbolOrSymbols?: string
  component: OrderTicketComponent
  caller: string
}

/**
 * Groups define collection of symbol for easier subscription management.
 */
export type SubscribeGroup = (
  'initial'
  | 'watchlist'
  | 'discover'
  | 'symbol-details'
  | 'my-account'
  | 'history'
  | 'create-order'
  | 'funds'
  | 'profile'
  | 'modify-order'
  | 'people-also-trade'
  | 'chart-details'
)

export type ProcessSymbolSubscribesPayload = {
  /** Comma separated string */
  symbolOrSymbols: string
  isFavorites?: boolean
  group: SubscribeGroup
  component?: OrderTicketComponent
  reInitializeGroup?: boolean;
  skipUnsubscribe?: boolean;
  customFeed?: MDSFeed | null
  /** Needed to follow the sequence of actions and helper executions */
  caller: string
  userCorrelationId?: number
}
export type ProcessSymbolUnSubscribesPayload = {
  /** Comma separated string */
  symbolOrSymbols: string
  /** These symbols will not be set to unsubscribed in SubscribeGroupCache */
  symbolsSkipCache?: string[]
  isRemovingFromFavorites?: boolean
  feed?: MDSFeed
  group?: SubscribeGroup
  /** Needed to follow the sequence of actions and helper executions */
  caller: string
  userCorrelationId?: number
}


export type MultipleOHLCVDataForPriceCalculation = {
  bucket: GWMarketDataSummaryBucket
  data: { [symbol: string]: OHLCV[] }
}

export type OHLCVDataForPriceCalculation = {
  bucket: GWMarketDataSummaryBucket
  data: OHLCV[]
}

export type MarketDataQueryPayload = {
  symbols: string[],
  bucket: GWMarketDataQueryBucket,
  endTime: string,
  startTime: string,
}

export type SymbolLite = {symbol: string};
export type UserFavoriteStocks = {[id: number]: SymbolLite[]};

export enum MarketDataCall {
  sendFavoriteStocksToServer,
  getFavoriteStocksFromServer,
}
